import { render, staticRenderFns } from "./LogoutConfirmDialog.vue?vue&type=template&id=165fdf7d&scoped=true&"
import script from "./LogoutConfirmDialog.vue?vue&type=script&lang=js&"
export * from "./LogoutConfirmDialog.vue?vue&type=script&lang=js&"
import style0 from "./LogoutConfirmDialog.vue?vue&type=style&index=0&id=165fdf7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165fdf7d",
  null
  
)

export default component.exports